var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { Wallpaper } from 'common/components/wallpaper';
import styles from './user-self-registration-layout.module.scss';
export var UserSelfRegistrationLayout = function () {
    return (_jsx("div", __assign({ className: styles.root }, { children: _jsx("div", __assign({ className: styles.contentWrapper }, { children: _jsx(Suspense, __assign({ fallback: _jsx(Wallpaper, {}) }, { children: _jsx(Outlet, {}) })) })) })));
};
